// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/logo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AchrhZ_rcsM8oL_N{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ")}", "",{"version":3,"sources":["webpack://./src/layouts/components/Header/src/layouts/components/Header/index.module.scss"],"names":[],"mappings":"AACA,kBAAA,wDAAA","sourcesContent":["@use \"breakpoints\" as *;\n.logo {\n  background-image: url('./assets/logo.png');\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logo": "AchrhZ_rcsM8oL_N"
};
export default ___CSS_LOADER_EXPORT___;
